/** Shared `page=` slug for voice selection in inbound, outbound scripts, and campaigns. */
export const VOICE_SELECTION_PAGE = "agent";

/** `voices=recommended` on the voice page opens the recommended-voices picker. */
export const VOICE_PICKER_PARAM = "voices";
export const VOICE_PICKER_RECOMMENDED = "recommended";

export const RECOMMENDED_VOICES_QUERY = `?page=${VOICE_SELECTION_PAGE}&${VOICE_PICKER_PARAM}=${VOICE_PICKER_RECOMMENDED}`;
